module.exports = __webpack_public_path__ + "img/Image - Header 5f.71f7faee.png";